export const cancelleriaTelematicaConfig: Array<{label: string, url: string, class: string}> = [
    // {
    //     label: "Consultazione giurisprudenza",
    //     url: "",
    //     class: "giurisprudenza"
    // },
    {
        label: "Gestione pagamenti telematici",
        url: "cancelleria-telematica/gestione-pagamenti",
        class: "pagamenti"
    },
    // {
    //     label: "Consultazione ReGIndE",
    //     url: "",
    //     class: "reginde"
    // },
    // {
    //     label: "Gestione deleghe",
    //     url: "cancelleria-telematica/gestione-deleghe",
    //     class: "deleghe"
    // },
    {
        label: "Aggiornamento massivo fascicoli",
        url: "",
        class: "aggiornamento_massivo"
    },
    // {
    //     label: "Consultazione ai fini della costituzione",
    //     url: "",
    //     class: "fini_costituzione"
    // },
    {
        label: "Consultazione",
        url: "cancelleria-telematica/consultazione",
        class: "consultazione"
    },
    {
        label: "Consultazione Anonima",
        url: "cancelleria-telematica/consultazione-anonima",
        class: "consultazione_anonima"
    }
];
